module.exports = __webpack_public_path__ + "img/glk.cdced8cb.jpg";